import * as CubiqTS from "shared/cubiq-model-multi-asset";

export class FlashingWaitClient {
  public orderID: string;
  public waitTime: CubiqTS.Moment;

  constructor(orderID: string, waitTime: CubiqTS.Moment) {
    this.orderID = orderID;
    this.waitTime = waitTime;
  }
}
